import {Directive, ElementRef, HostListener} from '@angular/core';

@Directive({
  selector: 'input[appNumbersOnly]',
  standalone: false
})
export class NumberOnlyDirective {
  // Allow decimal numbers and negative values
  private readonly regex: RegExp = new RegExp(
    /^(?<numbers>[0-9]+(?:[.][0-9]{0,5})?|\.[0-9]{1,5})$/g
  );
  private readonly specialKeys: string[] = [
    'Backspace',
    'Tab',
    'End',
    'Home',
    'ArrowLeft',
    'ArrowRight',
    'Del',
    'Delete',
    'Enter'
  ];

  constructor(private readonly el: ElementRef) {}
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (this.specialKeys.includes(event.key)) {
      return;
    }

    const current = this.el.nativeElement.value;
    const position = this.el.nativeElement.selectionStart;
    const next: string = [
      current.slice(0, position),
      event.key === 'Decimal' ? '.' : event.key,
      current.slice(position)
    ].join('');

    this.regex.lastIndex = 0;
    // eslint-disable-next-line
    if (next && !this.regex.exec(String(next))) {
      event.preventDefault();
    }
  }
}
